import {
  UI_COLOR_BORDER_INPUT,
  UI_COLOR_BORDER_INPUT_FOCUS,
  UI_COLOR_BORDER_INPUT_HOVER,
  UI_COLOR_BORDER_LIGHT,
  UI_COLOR_BORDER_SOFT,
  UI_COLOR_PRIMARY,
  UI_COLOR_TEXT_TITLE,
  UI_COLOR_TEXT_MUTED,
  UI_COLOR_TEXT_PLACEHOLDER,
  UI_COLOR_WHITE
} from '../../../constants/uiColors'

export const MOBILE_ADVANCED_FILTER_SEARCH_SX = {
  '& .MuiOutlinedInput-root': {
    minHeight: 37,
    borderRadius: '4px',
    bgcolor: UI_COLOR_WHITE,
    fontSize: 'calc(12.5px + var(--report-text-size-offset, 0px))'
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: UI_COLOR_BORDER_INPUT
  },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: UI_COLOR_BORDER_INPUT_HOVER
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: UI_COLOR_BORDER_INPUT_FOCUS,
    borderWidth: 1
  },
  '& .MuiInputBase-input': {
    py: 0.65,
    fontSize: 'calc(12.5px + var(--report-text-size-offset, 0px))',
    color: UI_COLOR_TEXT_MUTED,
    textAlign: 'left',
    direction: 'ltr',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    '&::placeholder': {
      color: UI_COLOR_TEXT_PLACEHOLDER,
      opacity: 1,
      textOverflow: 'ellipsis'
    }
  },
  '& .MuiInputAdornment-positionEnd': {
    marginLeft: 0.5
  }
}

export const MOBILE_ADVANCED_FILTER_FIELD_SX = {
  minWidth: 0,
  '& .mui-filter-select': {
    width: '100% !important'
  },
  '& .mui-filter-select__trigger': {
    height: '56px !important',
    borderRadius: '18px !important',
    border: `1px solid ${UI_COLOR_BORDER_INPUT} !important`,
    boxShadow: 'none !important',
    backgroundColor: `${UI_COLOR_WHITE} !important`
  },
  '& .mui-filter-select__trigger:hover': {
    borderColor: `${UI_COLOR_BORDER_INPUT_HOVER} !important`
  },
  '& .mui-filter-select__trigger--open': {
    borderColor: `${UI_COLOR_BORDER_INPUT_FOCUS} !important`,
    boxShadow: '0 0 0 1px rgba(89, 127, 169, 0.12) !important'
  },
  '& .mui-filter-select__content': {
    paddingLeft: '14px !important',
    paddingRight: '10px !important'
  },
  '& .mui-filter-select__title': {
    fontSize: 'calc(13px + var(--report-text-size-offset, 0px)) !important',
    fontWeight: '600 !important',
    color: `${UI_COLOR_TEXT_TITLE} !important`
  },
  '& .mui-filter-select__raised-label': {
    top: '-10px !important'
  },
  '& .mui-filter-select__raised-title': {
    fontSize: 'calc(12px + var(--report-text-size-offset, 0px)) !important',
    fontWeight: '700 !important',
    letterSpacing: '0.02em !important',
    color: `${UI_COLOR_PRIMARY} !important`
  },
  '& .mui-filter-select__paper': {
    borderRadius: '22px !important',
    padding: '16px 16px 12px !important',
    boxShadow: '0 18px 40px rgba(15, 23, 42, 0.18) !important'
  },
  '& .mui-filter-select__inline-layer': {
    position: 'absolute !important',
    top: 'calc(100% + 8px) !important',
    left: '0 !important',
    right: '0 !important',
    zIndex: '12 !important'
  },
  '& .mui-filter-select__paper--inline': {
    border: `1px solid ${UI_COLOR_BORDER_LIGHT} !important`,
    borderRadius: '18px !important',
    boxShadow: '0 16px 34px rgba(15, 23, 42, 0.14) !important',
    backgroundColor: `${UI_COLOR_WHITE} !important`
  },
  '& .mui-filter-select__paper--inline .mui-filter-select__options': {
    maxHeight: '220px !important'
  },
  '& .mui-filter-select__search-wrap': {
    marginBottom: '12px !important'
  },
  '& .mui-filter-select__search-input': {
    height: '37px !important',
    borderRadius: '4px !important',
    border: `1px solid ${UI_COLOR_BORDER_INPUT} !important`,
    backgroundColor: `${UI_COLOR_WHITE} !important`,
    padding: '0 12px !important',
    fontSize: 'calc(12.5px + var(--report-text-size-offset, 0px)) !important',
    color: `${UI_COLOR_TEXT_MUTED} !important`
  },
  '& .mui-filter-select__search-input:hover': {
    borderColor: `${UI_COLOR_BORDER_INPUT_HOVER} !important`
  },
  '& .mui-filter-select__search-input:focus-within': {
    borderColor: `${UI_COLOR_BORDER_INPUT_FOCUS} !important`,
    boxShadow: '0 0 0 1px rgba(89, 127, 169, 0.12) !important'
  },
  '& .mui-filter-select__search-input input::placeholder': {
    color: `${UI_COLOR_TEXT_PLACEHOLDER} !important`,
    opacity: '1 !important'
  },
  '& .mui-filter-select__select-all, & .mui-filter-select__option': {
    minHeight: '44px !important',
    alignItems: 'center !important',
    marginBottom: '10px !important'
  }
}

export const MOBILE_ADVANCED_FILTER_DATE_CARD_SX = {
  p: 2,
  borderRadius: '20px',
  border: `1px solid ${UI_COLOR_BORDER_LIGHT}`,
  bgcolor: UI_COLOR_WHITE,
  minWidth: 0
}

export const MOBILE_ADVANCED_FILTER_DATE_PICKER_TEXT_FIELD_SX = {
  '& .MuiOutlinedInput-root': {
    minHeight: 50,
    borderRadius: '16px',
    backgroundColor: UI_COLOR_WHITE
  },
  '& .MuiInputLabel-root': {
    fontWeight: 600
  }
}

export const MOBILE_ADVANCED_FILTER_DRAG_HANDLE_SX = {
  width: 44,
  height: 4,
  borderRadius: 999,
  bgcolor: UI_COLOR_BORDER_SOFT,
  mx: 'auto',
  mb: 1.5
}
